const WhatToKnowItems = [
    { id: '1', value: 'authorize' },
    { id: '2', value: 'cancelAnytime' },
    { id: '3', value: 'beginAfter' },
    {
        id: '4',
        value: 'jobLossAndLeave',
        subItems: [
            { id: '4-1', value: 'fullTime' },
            { id: '4-2', value: 'partTime' }
        ]
    },
    { id: '5', value: 'understandProgramFee' }
];
export default WhatToKnowItems;
